import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { X } from 'lucide-react';
import { motion } from 'framer-motion';
export const WhyFailed = () => {
  const items = ['Las encuestas pagas y las apps de microtareas pagan centavos que no cubren ni un café.', 'Los cursos de programación tardan meses (o años) en darte un sueldo real.', 'El trading requiere un capital que hoy no podés permitirte arriesgar.', 'Intentaste vender por tu cuenta pero no sabés por dónde empezar ni cómo cobrar afuera.'];
  return <AnimatedSection data-id="element-197">
      <div className="mb-12" data-id="element-198">
        <span className="uppercase tracking-widest text-xs font-semibold text-ink/50 block mb-4" data-id="element-199">
          POR QUÉ NO TE FUNCIONÓ ANTES
        </span>
        <h2 className="text-3xl md:text-4xl font-serif text-ink" data-id="element-200">
          Lo que ya probaste y por qué no alcanza
        </h2>
      </div>

      <div className="max-w-3xl space-y-6" data-id="element-201">
        {items.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1,
        duration: 0.5
      }} className="flex items-start gap-4 group" data-id="element-202">
            <div className="mt-1 flex-shrink-0 text-red-800/60" data-id="element-203">
              <X size={24} strokeWidth={1.5} data-id="element-204" />
            </div>
            <p className="text-lg font-sans text-ink/80 leading-relaxed relative" data-id="element-205">
              <span className="relative z-10" data-id="element-206">{item}</span>
              {/* Subtle strikethrough effect on hover */}
              <span className="absolute left-0 top-1/2 w-0 h-[1px] bg-red-800/30 transition-all duration-500 group-hover:w-full -z-0" data-id="element-207"></span>
            </p>
          </motion.div>)}
      </div>
    </AnimatedSection>;
};